export const GET_FEEDBACK = "GET_FEEDBACK";

export const GET_FEEDBACK_QUESTIONS = "GET_FEEDBACK_QUESTIONS";

export const GET_FEEDBACK_ANSWERS = "GET_FEEDBACK_ANSWERS";

export const UPDATE_FEEDBACK_DETAILS="UPDATE_FEEDBACK_DETAILS";

export const GET_VIDEO_LINK_DETAILS="GET_VIDEO_LINK_DETAILS";